export const INFO: IHeroSection = {
  headline: '',
  subHeadline: '',
  backgroundImage: '',
  backgroundImageMobile: '',
}
